import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import styles from './Layout.module.css';
import { format } from 'date-fns';
import ChangePasswordModal from '../ChangePasswordModal/ChangePasswordModal';

const navItems = [
  { label: 'Dashboard', icon: 'dashboard', path: '/admin' },
  { label: 'Cities', icon: 'location_city', path: '/admin/cities' },
  { label: 'Lines', icon: 'timeline', path: '/admin/lines' },
  { label: 'Stations', icon: 'train', path: '/admin/stations' },
  { label: 'Places', icon: 'place', path: '/admin/places' },
  { label: 'Station Connectors', icon: 'device_hub', path: '/admin/station-connections' },
  { label: 'Line Stations', icon: 'alt_route', path: '/admin/line-stations' },
  { label: 'Route Planning', icon: 'map', path: '/admin/route-planning' },
  { label: 'Plans', icon: 'card_membership', path: '/admin/plans' },
  { label: 'User Plans', icon: 'people', path: '/admin/user-plans' },
  { label: 'Users', icon: 'person', path: '/admin/users' },
  { label: 'Journeys', icon: 'directions_walk', path: '/admin/journeys' },
  { label: 'Journey Testing', icon: 'science', path: '/admin/journey-testing' },
  { label: 'Push Notifications', icon: 'notifications', path: '/admin/push-notifications' },
  { label: 'Incidents', icon: 'bug_report', path: '/admin/incidents' },
  { label: 'App Versions', icon: 'system_update', path: '/admin/app-versions' },
  { label: 'API Logs', icon: 'list_alt', path: '/admin/api-logs' },
  { label: 'Cache Management', icon: 'storage', path: '/admin/cache-management' },
  { label: 'Fare Rules', icon: 'local_atm', path: '/admin/fare-rules' },
  { label: 'Fare Conditions', icon: 'rule', path: '/admin/fare-conditions' },
  { label: 'Feature Flags', icon: 'flag', path: '/admin/feature-flags' },
];

const Layout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const today = format(new Date(), 'dd MMM, yyyy');
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/admin/login');
  };

  return (
    <div className={styles.appShell}>
      {/* Sidebar */}
      <aside className={styles.sidebar}>
        <div className={styles.logo}>MetroRahi</div>
        <nav className={styles.navMenu}>
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? styles.activeNav : styles.navItem}
            >
              <span className={`material-icons ${styles.navIcon}`}>{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className={styles.sidebarFooter}>
          <Link to="/" className={styles.homeLink}>
            <span className="material-icons">home</span> Homepage
          </Link>
          <button className={styles.logoutBtn} onClick={handleLogout}>
            <span className="material-icons">logout</span> Log out
          </button>
        </div>
      </aside>
      {/* Main Content */}
      <div className={styles.mainArea}>
        {/* Topbar */}
        <header className={styles.topbar}>
          <div>
            {/* Removed greeting and subtitle */}
          </div>
          <div className={styles.topbarRight}>
            <span className={styles.date}>{today}</span>
            <div 
              className={styles.avatarBox} 
              onClick={() => setShowChangePasswordModal(true)}
              style={{ cursor: 'pointer' }}
              title="Change Password"
            >
              <img
                src="https://randomuser.me/api/portraits/men/32.jpg"
                alt="User Avatar"
                className={styles.avatar}
              />
              <span className={styles.avatarName}>Admin</span>
              <span className="material-icons" style={{ marginLeft: '8px', fontSize: '16px' }}>lock</span>
            </div>
          </div>
        </header>
        <main className={styles.contentArea}>
          <Outlet />
        </main>
      </div>
      
      {/* Change Password Modal */}
      <ChangePasswordModal 
        open={showChangePasswordModal} 
        onClose={() => setShowChangePasswordModal(false)} 
      />
    </div>
  );
};

export default Layout; 